import { parse } from 'cookie';

export const getCookie = name => {
  if (typeof window !== 'undefined') {
    return parse(document?.cookie || '')[name] || null;
  }

  return null;
};
